import { useTranslation } from 'react-i18next'

import useCustomToast from '@/hooks/toasts'

import Copy from './Copy'

const Container = ({
    message,
    itemId,
    size,
    iconMarginRight,
}: {
    message: string
    itemId: number | null
    size?: string
    iconMarginRight?: string
}) => {
    const { t } = useTranslation()
    const [addToast] = useCustomToast()
    return (
        <Copy
            message={message}
            itemId={itemId}
            size={size}
            iconMarginRight={iconMarginRight}
            callback={() => {
                addToast('success', t('global.copy.toastMessage'))
            }}
        />
    )
}

export default Container
